exports.Incoterm = [
  {
    id: "id",
    name: "id",
    type: "text",
    value: "",
    label: "Id",
    key: "true",
    length: 3,
  },
  {
    id: "universalDescriptor",
    name: "universalDescriptor",
    type: "text",
    value: "",
    label: "Universal Descriptor",
    length: 50,
  },
  {
    id: "titlePassLocation",
    name: "titlePassLocation",
    type: "number",
    value: "",
    label: "Title Pass",
    ddid: "TitlePassLocation",
  },
  {
    id: "freightPayer",
    name: "freightPayer",
    type: "number",
    value: "",
    label: "Freight Payer",
    ddid: "FreightPayer",
  },
  {
    id: "localText",
    name: "localText",
    type: "text",
    value: "",
    label: "LocalText",
    length: 50,
  },
  {
    id: "createdBy",
    name: "createdBy",
    type: "text",
    label: "Created By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "createdOn",
    name: "createdOn",
    type: "datetime",
    label: "Created On",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedBy",
    name: "modifiedBy",
    type: "text",
    label: "Modified By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedOn",
    name: "modifiedOn",
    type: "datetime",
    label: "ModifiedOn",
    displayonly: "true",
    value: " ",
  },
];
